import { CTRL_COMMAND, } from "@/types/socket"
import { ctrlCmdModule } from "../modules/control-commands.module"

class WorkoutPreviewManager {

    start(id: string, type: string, workoutPartIdx: number, workoutRoundIdx?: number) {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.WORKOUT_PREVIEW_START,
            value: { id, type, workoutPartIdx, workoutRoundIdx }
        })
    }

    stop(id: string, type: string, workoutPartIdx: number, workoutRoundIdx?: number) {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.WORKOUT_PREVIEW_STOP,
            value: { id, type, workoutPartIdx, workoutRoundIdx }
        })
    }

    changeRound(id: string, type: string, workoutPartIdx: number, workoutRoundIdx: number) {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.WORKOUT_PREVIEW_CHANGE_ROUND,
            value: { id, type, workoutPartIdx, workoutRoundIdx }
        })
    }

    changeWorkoutPart(id: string, type: string, workoutPartIdx: number, workoutRoundIdx?: number) {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.WORKOUT_PREVIEW_CHANGE_PART,
            value: { id, type, workoutPartIdx, workoutRoundIdx }
        })
    }

    changeSlide(id: string, type: string, workoutPartIdx: number, slideIdx: number, workoutRoundIdx?: number) {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.WORKOUT_PREVIEW_CHANGE_SLIDE,
            value: { id, type, workoutPartIdx, workoutRoundIdx, slideIdx }
        })
    }

    showWhiteboard(id: string, type: string)
    {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.HYROX_WHITEBOARD_ACTIVATE,
            value: { id, type}
        })
    }

    showWhiteboardPage(id: string, page: number, type: string)
    {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.HYROX_WHITEBOARD_SHOW_PAGE,
            value: { id, type, page },
        })
    }

    showWhiteboardCoachtips(id: string, workoutPartIdx: number, type: string, coachTips: Array<{[key: string]: number|string}>) {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.HYROX_WHITEBOARD_SHOW_COACHTIPS,
            value: { id, type, workoutPartIdx, coachTips }
        })
    }

    hideWhiteboard(id: string, type: string)
    {
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.HYROX_WHITEBOARD_DEACTIVATE,
            value: { id, type }
        })
    }
}

export default new WorkoutPreviewManager()